export enum EnvironmentType {
    Local = 'local',
    Dev = 'dev',
    Sit = 'sit',
    Qa = 'qa',
    Prod = 'prod'
}
